module.exports = __webpack_public_path__ + "img/U1F916.c9eb34ef.png";